import React from 'react'
import Feedback from './Feedback'
import { Hero } from './Hero'

export const Home = () => {
  return (
    <div>
      
        <Hero/>
        <Feedback/>
        
    </div>
  )
}
